import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DeclineMessageModel } from "src/app/models/decline-message.model";
import { MySubscriptionModel } from "src/app/models/subscription/my-subscription.model";
import { SubscriptionModel } from "src/app/models/subscription/subscription.model";
import { SubscriptionsTemplateSummaryModel } from "src/app/models/subscription/subscriptions-template-summary.model";
import { TenantSubscriberModel } from "src/app/models/subscription/tenant-subscriber.model";
import { Configuration } from "src/assets/Configuration";

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {

  constructor(private httpClient: HttpClient) {
  }

  public getSubscriptionsTemplateSummary(): Observable<SubscriptionsTemplateSummaryModel> {
    return this.httpClient.get<SubscriptionsTemplateSummaryModel>(
      Configuration.getApiBaseUrl() + '/subscription/summary'
    );
  }

  public getTenantSubscribers(): Observable<TenantSubscriberModel[]> {
    return this.httpClient.get<TenantSubscriberModel[]>(
      Configuration.getApiBaseUrl() + '/subscription/subscribers'
    );
  }

  public getApprovedTenantSubscribers(): Observable<TenantSubscriberModel[]> {
    return this.httpClient.get<TenantSubscriberModel[]>(
      Configuration.getApiBaseUrl() + '/subscription/approved-subscribers'
    );
  }

  public getMySubscriptions(): Observable<MySubscriptionModel[]> {
    return this.httpClient.get<MySubscriptionModel[]>(
      Configuration.getApiBaseUrl() + '/subscription/my-subscriptions'
    );
  }

  public getMySubscription(
    tenantSubscriptionId: string
  ): Observable<MySubscriptionModel | null> {

    return this.httpClient.get<MySubscriptionModel | null>(
      Configuration.getApiBaseUrl() + '/subscription/my-subscriptions/' + tenantSubscriptionId
    );
  }


  public markProviderCategoriesAsReviewed(
    subscriptionId: string
  ): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() +
        '/subscription/' +
        subscriptionId +
        '/provider-categories/review',
      null
    );
  }

  public requestSubscription(providerTenantId: string): Observable<SubscriptionModel> {
    return this.httpClient.post<SubscriptionModel>(
      Configuration.getApiBaseUrl() + '/subscription/' + providerTenantId + '/request',
      null
    );
  }

  public subscribeToProvidedTenant(
    providerTenantId: string,
    disabledStandardCategoryIds: string[]
  ): Observable<SubscriptionModel> {
    return this.httpClient.post<SubscriptionModel>(
      Configuration.getApiBaseUrl() +
        '/subscription/' +
        providerTenantId +
        '/subscribe',
      { disabledStandardCategoryIds }
    );
  }

  public grantApproval(consumerTenantId: string): Observable<SubscriptionModel> {
    return this.httpClient.put<SubscriptionModel>(
      Configuration.getApiBaseUrl() + '/subscription/' + consumerTenantId + '/grant',
      null
    );
  }

  public cancelSubscription(providerTenantId: string): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() + '/subscription/providers/' + providerTenantId,
    );
  }

  public removeSubscriber(consumerTenantId: string): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() + '/subscription/consumers/' + consumerTenantId,
    );
  }

  public rejectRequest(subscriptionId: string, model: DeclineMessageModel): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + '/subscription/requests/' + subscriptionId,
      model
    );
  }

  public getSubscription(
    providerTenantId: string,consumerTenantId: string
  ): Observable<SubscriptionModel | null> {
    const params = new HttpParams()
      .set('providerTenantId', providerTenantId)
      .set('consumerTenantId', consumerTenantId);

    return this.httpClient.get<SubscriptionModel | null>(
      Configuration.getApiBaseUrl() + '/subscription',
      { params }
    );
  }
}